import { Middleware } from 'redux'
import USER from './user.constants'
import ApiEndpoint, { ApiError, ApiResponse } from '../../network/ApiEndpoint'
import authenticationActions from '../authentication/authentication.actions'
import userActions from './user.actions'
import notificationActions from 'redux-store/native/notification/notification.actions'
import { User } from 'interfaces'
import { followedCompaniesExpanedSelector } from './user.selectors'

export const addUser: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (action.type === USER.USER_ADDED) {
      storeAPI.dispatch(
        notificationActions.requestNotifications(
          (action.user as User).followed_companies_expanded
        )
      )
    }
    return next(action)
  }

export const removeUser: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (action.type === USER.USER_REMOVED) {
      const channels = followedCompaniesExpanedSelector(storeAPI.getState())
      if (channels && channels.length > 0) {
        storeAPI.dispatch(notificationActions.unsubscribeFrom(channels))
      }
    }
    return next(action)
  }

export const updateUser: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (action.type === USER.UPDATE_USER) {
      ApiEndpoint.call({
        path: 'users/session_user',
        method: ApiEndpoint.METHODS.GET,
        authenticatable: true
      })
        .then((response: ApiResponse) => {
          storeAPI.dispatch(userActions.userUpdatedFromServer(response.data))
        })
        .catch((error: ApiError) => {
          console.error(error)
          storeAPI.dispatch(authenticationActions.openLoginLayer())
          storeAPI.dispatch(userActions.userUpdateFailed())
        })
    }
    return next(action)
  }

export const companyFollowAdd: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (action.type === USER.COMPANY_FOLLOW_ADD) {
      if (!action.company) {
        throw new Error('Company not found')
      }
      storeAPI.dispatch(notificationActions.subscribeTo([action.company]))
    }
    return next(action)
  }

export const companyFollowRemove: Middleware<unknown, {}, any> =
  (storeAPI: any) => (next) => (action) => {
    if (action.type === USER.COMPANY_FOLLOW_REMOVE) {
      if (!action.company) {
        throw new Error('Company not found')
      }
      storeAPI.dispatch(notificationActions.unsubscribeFrom([action.company]))
    }
    return next(action)
  }
